var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMySpaceIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2699 29.2599C21.8338 30.4422 26.1613 29.851 26.1613 26.8955C26.1613 24.531 21.2156 25.1221 18.7428 26.3043C14.8275 28.0777 6.25493 31.2697 3.28752 29.851C-0.421746 28.0777 1.99978 25.3183 3.90573 25.1221C6.5466 24.8503 11.1184 25.5162 13.1792 26.3043C15.2398 25.3192 19.7319 22.2848 21.2156 18.0287C23.0703 12.7087 20.5974 11.5265 19.361 10.9354C18.3719 10.4625 14.0032 10.3442 11.9425 10.3442C8.85141 10.3442 4.09107 11.5265 5.76064 16.2554C6.34147 17.9005 8.41855 20.9843 13.1792 23.3488C15.2398 21.9695 19.2374 18.3834 18.7428 15.0732C18.1246 10.9354 13.7971 13.2998 13.1789 13.8909C12.5607 13.2998 10.9533 12.2358 9.46963 12.7087C7.61499 13.2998 6.99678 15.6643 8.85142 17.4376",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7563 4.43304C16.7563 5.94629 15.4634 7.22974 13.797 7.22974C12.1306 7.22974 10.8378 5.94629 10.8378 4.43304C10.8378 2.9198 12.1306 1.63635 13.797 1.63635C15.4634 1.63635 16.7563 2.9198 16.7563 4.43304Z",
    stroke: "#000",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMySpaceIconBlack);
export default __webpack_public_path__ + "static/media/MySpaceIcon_black.01436de220d3c728b330850d2bd66638.svg";
export { ForwardRef as ReactComponent };